module.exports = __webpack_public_path__ + "img/prop-cloud-2.4b35f832.webp";